const state = {
	submittedSurvey: false,
	translationValidations: false,
	submittedStories: false,
	promotedProjects: []
}

const getters = {
	getPromoteOption: (state) => (fieldName) => {
		return state[fieldName];
	},
	isPromotionApplicable: (state) => {
		return state.submittedSurvey.isValid || state.translationValidations.isValid || state.submittedStories.isValid
	},
	getValidPromoteOption: (state) => {
		if (state.submittedSurvey.isValid) {
			return {
				optionType: 'FILLED_SURVEY',
				applicableIds: state.submittedSurvey.applicableFilledSurveyIds
			}
		}

		if (state.translationValidations.isValid) {
			return {
				optionType: 'TRANSLATION_VALIDATION',
				applicableIds: state.translationValidations.applicableTranslations
			}
		}

		if (state.submittedStories.isValid) {
			return {
				optionType: 'SUBMITTED_PROJECT',
				applicableIds: state.submittedStories.applicableProjects
			}
		}
	}
}

const actions = {
	setPromoteOption({commit}, {fieldName, value}) {
		commit('changePromoteOption', {fieldName, value});
	},
}

const mutations = {
	changePromoteOption(state, {fieldName, value}) {
		state[fieldName] = value;
	}
}

export default {state, getters, actions, mutations};
